import { useRef, useLayoutEffect } from 'react';

const isBrowser = typeof window !== `undefined`;

const getScrollPosition = ({ element, useWindow }) => {
	if (!isBrowser) return { x: 0, y: 0 };

	const target = element ? element.current : document.body;
	const position = target.getBoundingClientRect();

	return useWindow
		? { x: window.scrollX, y: window.scrollY }
		: { x: position.left, y: position.top };
};

const useScrollPosition = (effect, deps, element, useWindow, wait) => {
	const position = useRef(getScrollPosition({ useWindow }));

	const throttleTimeout = useRef(null);

	const getPosition = () => {
		const currPos = getScrollPosition({ element, useWindow });
		effect({ prevPos: position.current, currPos });
		position.current = currPos;
		throttleTimeout.current = null;
	};

	useLayoutEffect(() => {
		const handleScroll = () => {
			if (wait && !throttleTimeout.current) {
				throttleTimeout.current = setTimeout(getPosition, wait);
			} else {
				getPosition();
			}
		};

		window.addEventListener('scroll', handleScroll);

		return () => window.removeEventListener('scroll', handleScroll);
	}, deps);
};

export default useScrollPosition;
